<div class="lab" [class.light]="tema === 'light'">
  <header class="lab-top">
    <div class="lab-brand"><i nz-icon nzType="thunderbolt" nzTheme="fill"></i> Fórmula Lab</div>
    <div class="lab-top-actions">
      <button type="button" class="lab-icon-btn" (click)="toggleTema()"
              [title]="tema === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'" aria-label="Alternar tema">
        <i nz-icon nzType="bulb" [nzTheme]="tema === 'light' ? 'fill' : 'outline'"></i>
      </button>
      <button type="button" class="lab-switch" [class.on]="aviator" (click)="toggleAviator()"
              [attr.aria-pressed]="aviator" title="Modo Aviator Script">
        <span class="lab-knob"></span><span class="lab-switch-txt">modo aviator</span>
      </button>
      <button type="button" class="lab-switch" [class.on]="modo === 'code'" (click)="toggleModo()"
              [attr.aria-pressed]="modo === 'code'" title="Modo código: múltiplas fórmulas em sequência com setVar">
        <span class="lab-knob"></span><span class="lab-switch-txt">modo código</span>
      </button>
      <button type="button" class="lab-switch" [class.on]="novo" (click)="novo = !novo"
              [attr.aria-pressed]="novo" title="Motor novo (limpo) x antigo (resultado entre aspas)">
        <span class="lab-knob"></span><span class="lab-switch-txt">motor novo</span>
      </button>
      <button type="button" class="lab-btn lab-btn-ghost" (click)="limpar()"><i nz-icon nzType="delete"></i> Limpar</button>
      <button type="button" class="lab-btn lab-btn-run" (click)="testar()" [disabled]="loading">
        <i nz-icon [nzType]="loading ? 'loading' : 'caret-right'"></i> Testar
      </button>
    </div>
  </header>

  <div class="lab-body">
    <!-- EXPLORER -->
    <aside class="lab-explorer">
      <div class="lab-search">
        <i nz-icon nzType="search"></i>
        <input [ngModel]="filtro" (ngModelChange)="filtrar($event)" placeholder="Buscar função..." aria-label="Buscar função" />
      </div>
      <div class="lab-cats">
        <div class="lab-cat" *ngFor="let c of categorias">
          <button type="button" class="lab-cat-head" (click)="toggleCat(c)" [attr.aria-expanded]="c.aberta">
            <i nz-icon [nzType]="c.aberta ? 'down' : 'right'" class="lab-caret"></i>
            <i nz-icon [nzType]="c.icon" class="lab-cat-ic"></i>
            <span class="lab-cat-label">{{ c.label }}</span>
            <span class="lab-cat-count">{{ c.items.length }}</span>
          </button>
          <div class="lab-cat-items" *ngIf="c.aberta">
            <div class="lab-fn" *ngFor="let f of c.items" [class.sel]="selected === f"
                 (click)="selecionar(f)" (dblclick)="inserir(f)">
              <div class="lab-fn-line">
                <span class="lab-fn-name">{{ f.name }}</span>
                <button type="button" class="lab-fn-add" title="Inserir no editor"
                        (click)="inserir(f); $event.stopPropagation()"><i nz-icon nzType="plus"></i></button>
              </div>
              <div class="lab-fn-desc">{{ f.description }}</div>
            </div>
          </div>
        </div>
        <div class="lab-empty" *ngIf="!categorias.length">Nenhuma função</div>
      </div>
    </aside>

    <!-- EDITOR -->
    <main class="lab-main">
      <div class="lab-panel-label">
        <i nz-icon [nzType]="modo === 'code' ? 'code' : 'function'"></i>
        <span *ngIf="modo === 'single'">Fórmula</span>
        <span *ngIf="modo === 'code'">Código <span class="lab-mode-badge">setVar + multi-linha</span></span>
      </div>
      <div #aceHost class="lab-ace"></div>

      <ng-container *ngIf="modo === 'code'">
        <div class="lab-code-hint">
          <i nz-icon nzType="info-circle"></i>
          Use <code>setVar(@NOME, formula)</code> para declarar variáveis e referenciá-las como <code>&#123;@NOME&#125;</code> nas linhas seguintes.
          Linhas começando com <code>//</code> são comentários. O resultado da última linha é o retorno.
        </div>
      </ng-container>

      <div class="lab-sub">
        <div class="lab-panel-label between">
          <span><i nz-icon nzType="tag"></i> Variáveis</span>
          <button type="button" class="lab-btn lab-btn-mini" (click)="addVariavel()"><i nz-icon nzType="plus"></i> adicionar</button>
        </div>
        <div class="lab-vars">
          <div class="lab-var" *ngFor="let v of listvariable; let i = index">
            <input class="lab-in key" [(ngModel)]="v.key" (ngModelChange)="variavelMudou()" placeholder="@CHAVE" />
            <input class="lab-in val" [(ngModel)]="v.value" (ngModelChange)="variavelMudou()" placeholder="valor" />
            <select class="lab-in type" [(ngModel)]="v.type"><option *ngFor="let t of tipos" [value]="t">{{ t }}</option></select>
            <button type="button" class="lab-x danger" (click)="removeVariavel(i)" title="Remover"><i nz-icon nzType="close"></i></button>
          </div>
          <div class="lab-empty small" *ngIf="!listvariable.length">
            <ng-container *ngIf="modo === 'single'">Use <code>&#123;@CHAVE&#125;</code> na fórmula e declare aqui.</ng-container>
            <ng-container *ngIf="modo === 'code'">Variáveis externas opcionais. No código, use <code>setVar(@NOME, ...)</code> para criar variáveis internas.</ng-container>
          </div>
        </div>
      </div>

      <div class="lab-sub">
        <div class="lab-panel-label"><i nz-icon nzType="bulb"></i> Exemplos</div>
        <div class="lab-examples">
          <button type="button" class="lab-chip" *ngFor="let ex of exemplos" (click)="carregarExemplo(ex)">{{ ex.label }}</button>
        </div>
      </div>
    </main>

    <!-- RESULT -->
    <section class="lab-result">
      <div class="lab-panel-label between">
        <span><i nz-icon nzType="play-circle"></i> Resultado</span>
        <span class="lab-meta" *ngIf="tempoMs !== null">
          <span class="lab-pill" [class.err]="error" [class.ok]="!error">{{ error ? 'erro' : 'ok' }}</span>
          <span class="lab-pill type" *ngIf="!error && resultado !== null">{{ tipoResultado }}</span>
          <span class="lab-ms">{{ tempoMs }} ms</span>
          <button type="button" class="lab-x" *ngIf="!error && resultado !== null" (click)="copiar()"
                  [title]="copiado ? 'Copiado' : 'Copiar'"><i nz-icon [nzType]="copiado ? 'check' : 'copy'"></i></button>
        </span>
      </div>

      <!-- trace em modo código -->
      <div class="lab-trace" *ngIf="modo === 'code' && traceLines.length">
        <div class="lab-trace-item" *ngFor="let t of traceLines" [class.err]="t.error" [class.setvar]="!!t.varSet">
          <span class="lab-trace-line">{{ t.lineNo }}</span>
          <span class="lab-trace-formula">{{ t.formula }}</span>
          <span class="lab-trace-arrow">
            <ng-container *ngIf="t.varSet">{{ t.varSet }} =</ng-container>
            <ng-container *ngIf="!t.varSet && !t.error">&#8594;</ng-container>
          </span>
          <span class="lab-trace-result" *ngIf="!t.error">{{ traceResultadoTexto(t.result) }}</span>
          <span class="lab-trace-error" *ngIf="t.error">{{ t.error }}</span>
          <span class="lab-trace-ms">{{ t.ms }}ms</span>
        </div>
      </div>

      <div class="lab-console" [class.loading]="loading">
        <div class="lab-err" *ngIf="error">{{ error }}</div>
        <div class="lab-nota" *ngIf="notaExemplo && !error && resultado === null">
          <b>Exemplo nao executavel no laboratorio.</b><br />{{ notaExemplo }}
        </div>
        <pre class="lab-out" *ngIf="!error && resultado !== null">{{ resultadoTexto }}</pre>
        <div class="lab-placeholder" *ngIf="!error && resultado === null && !notaExemplo">
          <ng-container *ngIf="modo === 'single'">Escreva uma fórmula e clique <b>Testar</b> (ou edite e veja ao vivo).</ng-container>
          <ng-container *ngIf="modo === 'code'">Escreva um script com múltiplas fórmulas e clique <b>Testar</b>. Use <code>setVar(@X, formula)</code> para encadear resultados.</ng-container>
        </div>
      </div>

      <div class="lab-doc" *ngIf="selected">
        <div class="lab-doc-title">
          <i nz-icon nzType="thunderbolt"></i> {{ selected.name }}
          <span class="lab-ret" *ngIf="selected.retorna">retorna {{ selected.retorna }}</span>
        </div>
        <div class="lab-doc-desc">{{ selected.description }}</div>
        <code class="lab-doc-sig" *ngIf="selected.sintaxe">{{ selected.sintaxe.expression }}({{ selected.sintaxe.parameters?.join(', ') }})</code>
        <ng-container *ngIf="selected.exemplo">
          <div class="lab-ex-lab">
            exemplo
            <span class="lab-ex-res" *ngIf="selected.validado">= {{ selected.resultado }}</span>
            <span class="lab-ex-tpl" *ngIf="!selected.runnable">sintaxe (requer contexto)</span>
          </div>
          <code class="lab-doc-sig ex">{{ selected.exemplo }}</code>
        </ng-container>
        <div class="lab-doc-combina" *ngIf="selected.combina">{{ selected.combina }}</div>
        <div class="lab-doc-actions">
          <button type="button" class="lab-btn lab-btn-ghost sm" (click)="inserir(selected)"><i nz-icon nzType="plus"></i> Inserir</button>
          <button type="button" class="lab-btn lab-btn-run sm" *ngIf="selected.exemplo" (click)="testarExemplo(selected)"><i nz-icon nzType="caret-right"></i> Usar exemplo</button>
        </div>
      </div>
    </section>
  </div>

  <footer class="lab-dialog-footer" *ngIf="popup">
    <button type="button" class="lab-btn lab-btn-ghost" (click)="cancelar()">Cancelar</button>
    <button type="button" class="lab-btn lab-btn-run" (click)="confirmar()"><i nz-icon nzType="check"></i> Usar fórmula</button>
  </footer>
</div>
